module.exports = __webpack_public_path__ + "recommend.png?be2055738820b8bbc5396b458db830a4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recommend.png
// module id = 184
// module chunks = 0